import { Schema } from "@comparaonline/products-schema";

export const isProductPartner = (product: Schema.ProductListProduct) =>
  Boolean(product.partner || product.division.partner);
